<template>
<modal @close="onModalClose">
    <template slot="header">
        {{ tenant.first_name }} {{ tenant.last_name }}
        (Unit {{ tenant.unit }})
    </template>

    <template slot="content">
        <div class="flex jc-sb">
            <div>
                <label>Current Status:</label>
                <span>{{ tenant.status }}</span>
            </div>

            <div>
                <label>New Status:</label>
                <radio-list
                    :choices="new_status_choices"
                    :current-value="new_status"
                    @change="(v) => new_status = v" />
            </div>
        </div>

    </template>

    <template slot="footer">
        <div class="flex ai-c jc-fe">
            <span v-show="is_saving" class="mr-3">
                <img src="../assets/img/loading-black-32.gif" alt="loading" />
            </span>

            <button
                :disabled="!save_button_enabled"
                type="button"
                @click="saveStatus">
                Save
            </button>
        </div>
    </template>
</modal>
</template>

<script>
import http from "@/http"

export default {
    name: "edit-tenant-status-modal",

    props: {
        tenant: {
            required: true,
            type: Object
        }
    },

    data () {
        return {
            is_saving: false,
            new_status: null,
            new_status_choices: [
                { name: "provide_proof", label: "Provided Proof" },
                { name: "opt_out", label: "Opted Out" },
                { name: "moved_out", label: "Moved Out" },
                { name: "bad_address", label: "Bad Address" },
                { name: "no_response", label: "No Response" }
            ]
        }
    },

    computed: {
        save_button_enabled () {
            if (this.is_saving) {
                return false
            }

            const currentChoice = this.new_status_choices.filter((choice) => {
                return choice.name === this.new_status
            })[0]

            if (currentChoice === undefined) {
                return false
            }

            return currentChoice.label !== this.tenant.status
        }
    },

    methods: {
        onModalClose () {
            if (!this.is_saving) {
                this.$emit("close")
            }
        },

        async saveStatus () {
            const currentChoice = this.new_status_choices.filter((choice) => {
                return choice.name === this.new_status
            })[0]

            if (currentChoice !== undefined) {
                this.is_saving = true

                try {
                    const params = new URLSearchParams()
                    params.append("status", currentChoice.name)

                    await http.post(`/api/tenants/${this.tenant.id}/status`, params)

                    this.$emit("update", { status: currentChoice.label })
                } catch (ex) {
                    console.log(ex)
                } finally {
                    this.is_saving = false
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/EditTenantStatusModal.vue